import script from "./indexAddRepairRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./indexAddRepairRequest.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__